import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacilitiesComponent } from './components/facilities/facilities.component';
import { FacilityDetailComponent } from './components/facility-detail/facility-detail.component';
import { StatusPageRoutingModule } from './status-page-routing.module';
import { FacilityComponent } from './components/facilities/facility/facility.component';
import { FacilityExtendedComponent } from './components/facilities/facility-extended/facility-extended.component';
import { FacilityExtendedFullComponent } from './components/facilities/facility-extended-full/facility-extended-full.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { EmergencyAlarmsComponent } from './components/emergency-alarms/emergency-alarms.component';
import { OccupationRatiosComponent } from './components/facilities/facility-extended/occupation-ratios/occupation-ratios.component';
import { TotalOccupationRatioComponent } from './components/facilities/facility-extended-full/total-occupation-ratio/total-occupation-ratio.component';
import { OtherOccupationRatioComponent } from './components/facilities/facility-extended-full/other-occupation-ratio/other-occupation-ratio.component';
import { NotificationsFilterComponent } from './components/notifications/notifications-filter/notifications-filter.component';
import { NotificationGroupComponent } from './components/notifications/notification-group/notification-group.component';
import { NotificationPlaceholderComponent } from './components/notifications/notification-placeholder/notification-placeholder.component';
import { NotificationActionsComponent } from './components/notifications/notification/notification-actions/notification-actions.component';
import { TerminalsComponent } from './components/terminals/terminals.component';
import { TerminalComponent } from './components/terminals/terminal/terminal.component';
import { TerminalTypeComponent } from './components/terminals/terminal-type/terminal-type.component';
import { TotalsComponent } from './components/totals/totals.component';
import { ActivityComponent } from './components/activity/activity.component';
import { ContextualActionsComponent } from './components/contextual-actions/contextual-actions.component';
import { ActionComponent } from './components/contextual-actions/action/action.component';
import { SearchResultComponent } from './components/terminals/terminal-actions-dialog/identification/search-result/search-result.component';
import { SearchComponent } from './components/terminals/terminal-actions-dialog/identification/search/search.component';
import { NotificationComponent } from './components/notifications/notification/notification.component';
import { FacilityEmergencyAlarmsComponent } from './components/facility-emergency-alarms/facility-emergency-alarms.component';
import { SharedModule } from 'src/app/@shared/shared.module';
import { TerminalActionsDialogComponent } from './components/terminals/terminal-actions-dialog/terminal-actions-dialog.component';
import { BypassAlarmsComponent } from './components/bypass-alarms/bypass-alarms.component';
import { AnonymousPassageComponent } from './components/terminals/terminal-actions-dialog/anonymous-passage/anonymous-passage.component';
import { ControlledPassageComponent } from './components/terminals/terminal-actions-dialog/controlled-passage/controlled-passage.component';
import { TerminalStatusComponent } from './components/terminals/terminal-actions-dialog/terminal-status/terminal-status.component';
import { AccessModeComponent } from './components/terminals/terminal-actions-dialog/access-mode/access-mode.component';
import { IdentificationComponent } from './components/terminals/terminal-actions-dialog/identification/identification.component';
import { TerminalScreenComponent } from './components/terminals/terminal-actions-dialog/terminal-screen/terminal-screen.component';
import { NbAlertModule, NbAutocompleteModule } from '@nebular/theme';
import { TerminalEventsComponent } from './components/terminals/terminal-actions-dialog/terminal-events/terminal-events.component';
import { PaymentScreenComponent } from './components/terminals/terminal-actions-dialog/payment-screen/payment-screen.component';
import { LoopAccessComponent } from './components/terminals/terminal-actions-dialog/loop-access/loop-access.component';
import { ExchangeLaneComponent } from './components/terminals/terminal-actions-dialog/exchange-lane/exchange-lane.component';
import { NotificationDescriptionComponent } from './components/notifications/notification-description/notification-description.component';
import { TerminalNameComponent } from './components/terminals/terminal-name/terminal-name.component';

@NgModule({
  declarations: [
    FacilitiesComponent,
    FacilityDetailComponent,
    FacilityComponent,
    FacilityExtendedComponent,
    FacilityExtendedFullComponent,
    NotificationsComponent,
    EmergencyAlarmsComponent,
    OccupationRatiosComponent,
    TotalOccupationRatioComponent,
    OtherOccupationRatioComponent,
    NotificationsFilterComponent,
    NotificationsComponent,
    NotificationComponent,
    NotificationGroupComponent,
    NotificationPlaceholderComponent,
    NotificationActionsComponent,
    TerminalsComponent,
    TerminalComponent,
    TerminalTypeComponent,
    TotalsComponent,
    ActivityComponent,
    ContextualActionsComponent,
    ActionComponent,
    SearchComponent,
    SearchResultComponent,
    FacilityEmergencyAlarmsComponent,
    TerminalActionsDialogComponent,
    BypassAlarmsComponent,
    AnonymousPassageComponent,
    ControlledPassageComponent,
    TerminalStatusComponent,
    AccessModeComponent,
    IdentificationComponent,
    TerminalScreenComponent,
    TerminalEventsComponent,
    PaymentScreenComponent,
    LoopAccessComponent,
    ExchangeLaneComponent,
    NotificationDescriptionComponent,
    TerminalNameComponent,
  ],
  imports: [
    CommonModule,
    StatusPageRoutingModule,
    SharedModule,
    NbAutocompleteModule,
    NbAlertModule,
  ],
  exports: [NotificationsComponent],
})
export class StatusPageModule {
  constructor() {}
}
